import { useEffect, useState } from 'react';
import { BrandHistory } from '@app/models';
import { ComponentErrorBoundary } from '@app/utilities';
import { ContentHeader } from '@app/shared';
import { JsonViewer } from '@textea/json-viewer';
import { ScrollableContentContainer } from '../components/ScrollableContentContainer';

export function GetBrandHistory({ selectedBrand }: { selectedBrand: BrandHistory }) {
  const [brand, setBrand] = useState<BrandHistory>();
  useEffect(() => {
    if (!selectedBrand) {
        setBrand(null);
      return;
    }
    setBrand({
      ...selectedBrand
    });
  }, [selectedBrand]);

  return (
    <ComponentErrorBoundary>
      <div className={'ui segment basic container'}>
          <div className={'ui segment'}>
              <ContentHeader>History</ContentHeader>
              <ScrollableContentContainer height={'350px'}>
              <JsonViewer value={selectedBrand} />
              </ScrollableContentContainer>
          </div>
      </div>
    </ComponentErrorBoundary>
  );
}
